import { createApp } from "vue";
import App from "./App.vue";
import "./assets/css/index.css";
import axios from "axios";
import VueAxios from "vue-axios";
import Toaster from "@meforma/vue-toaster";
import router from "./router";

const app = createApp(App);

app.config.performance = true;
axios.defaults.baseURL = "https://backend.deliradio.nyc/wp-json";
app.config.globalProperties.$axios = axios;

app.use(router);
app.use(VueAxios, axios);
app.use(Toaster);
app.mount("#app");